export const getFilteredMenuForPromotion = (
  promotionItems,
  menuItem,
  sectionTitle
) => {
  const results = [];
  const resultItems = [];

  for (const [index, promoItem] of promotionItems.entries()) {
    if (menuItem.byId[promoItem.id]) {
      resultItems.push({
        id: promoItem.id,
        order: index,
        product: menuItem.byId[promoItem.id]
      });
    }
  }
  if (resultItems.length) {
    const newSection = {
      name: sectionTitle,
      items: resultItems
    };
    results.push(newSection);
  }

  return results;
};
